import React from 'react';
import cn from 'classnames';

import type { DsTextColor } from './typographyTextColor';
import { dsTextColorClassMap } from './typographyTextColor';

export interface SubtitleProps {
  weight?: 'regular' | 'semibold' | 'medium';
  color?: DsTextColor;
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
}

export const Subtitle: React.FC<SubtitleProps> = ({
  weight = 'regular',
  color = 'primary',
  children,
  as: Component = 'div',
  className,
}) => {
  const classes = cn(
    dsTextColorClassMap[color],
    'text-ds-subtitle',
    {
      'font-normal': weight === 'regular',
      'font-semibold': weight === 'semibold',
      'font-medium': weight === 'medium',
    },
    className,
  );

  return <Component className={classes}>{children}</Component>;
};

export default Subtitle;
